import { render } from "./SendoutRemovePopup.vue?vue&type=template&id=20db3b5e&scoped=true"
import script from "./SendoutRemovePopup.vue?vue&type=script&lang=js"
export * from "./SendoutRemovePopup.vue?vue&type=script&lang=js"

import "./SendoutRemovePopup.vue?vue&type=style&index=0&id=20db3b5e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20db3b5e"],['__file',"src/components/cases/SendoutRemovePopup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20db3b5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20db3b5e', __exports__)) {
    console.log('reload')
    api.reload('20db3b5e', __exports__)
  }
  
  module.hot.accept("./SendoutRemovePopup.vue?vue&type=template&id=20db3b5e&scoped=true", () => {
    console.log('re-render')
    api.rerender('20db3b5e', render)
  })

}


export default __exports__